class MyLocalStorage {
  /**
   * key表示设置的key值，value存储的时候，time有效期单位分钟
   */
  setItem(key:string, value:any, minuteTime:number){
    let expires = 0
    if(minuteTime){
      // 计算存储时的有效时间需要转化为毫秒
      expires = new Date().getTime() + minuteTime * 1000 * 60
    }
    let storageData = JSON.stringify({value, expires})
    localStorage.setItem(key, storageData)  // 存储数据
  }
  getItem(key:string){
    const item:any = localStorage.getItem(key)
    const getData = JSON.parse(item)
    if(!getData){
      return null
    }
    // 说明已经过期了
    if(getData.expires < new Date().getTime()){
      // 移除 Storage
      this.removeItem(key)
      return null
    }
    return getData.value
  }
  // 移除 Storage
  removeItem(key:string){
    localStorage.removeItem(key)
  }
}
export const myLocalStorage:MyLocalStorage = new MyLocalStorage()
